const personalRouter = [
	{
		path: '/messageBoard',
		name: 'MessageBoard',
		component: () => import('@/views/personal/MessageBoardIndex')
	},
	{
		path: '/personal/messageBoard',
		name: 'MessageBoard',
		component: () => import('@/views/personal/MessageBoard')
	},
	{
		path: '/personal/messageBoardList',
		name: 'MessageBoardList',
		component: () => import('@/views/personal/MessageBoardList')
	},
	{
		path: '/personal/notificationList',
		name: 'NotificationList',
		component: () => import('@/views/personal/NotificationList')
	},
	{
		path: '/personal/notificationInfo',
		name: 'NotificationInfo',
		component: () => import('@/views/personal/NotificationInfo')
	},
	{
		path: '/personal/subsidies/taxSubsidies',
		name: 'TaxSubsidies',
		component: () => import('@/views/personal/subsidies/TaxSubsidies')
	},
	{
		path: '/personal/subsidies/taxSubsidiesApply',
		name: 'TaxSubsidiesApply',
		component: () => import('@/views/personal/subsidies/TaxSubsidiesApply')
	},
	{
		path: '/personal/subsidies/taxQsSubsidiesApply',
		name: 'TaxQsSubsidiesApply',
		component: () => import('@/views/personal/subsidies/TaxQsSubsidiesApply')
	},
	{
		path: '/personal/subsidies/taxSubsidiesApplyDetails',
		name: 'TaxQsSubsidiesApply',
		component: () => import('@/views/personal/subsidies/TaxSubsidiesApplyDetails')
	},
]
export default personalRouter
